'use client';

import { useEffect } from 'react';
import { useBackButton } from './back-button-context';

interface UsePageBackButtonOptions {
  fallbackUrl?: string;
}

export function usePageBackButton(options: UsePageBackButtonOptions = {}) {
  const { setShowBackButton, setBackButtonFallback } = useBackButton();
  const { fallbackUrl = '/' } = options;

  useEffect(() => {
    // Show back button when component mounts
    setShowBackButton(true);
    setBackButtonFallback(fallbackUrl);

    // Hide back button when component unmounts
    return () => {
      setShowBackButton(false);
    };
  }, [setShowBackButton, setBackButtonFallback, fallbackUrl]);
}
